import { api } from '../api.js';
import { renderHeader, bindHeader } from '../components/header.js';
import { toast } from '../utils/toast.js';

function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleString('ru', { dateStyle: 'short', timeStyle: 'short' });
}
function escapeHtml(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export async function renderAdminUsersPage({ root }) {
  root.innerHTML = renderHeader({ active: 'admin' }) + `
    <div class="container admin-container">
      <h1 class="admin-title">Пользователи</h1>
      <div class="admin-toolbar">
        <input type="search" id="admin-search" placeholder="Поиск по email…" />
        <div class="text-muted" id="admin-count"></div>
      </div>
      <div id="admin-users-table" class="admin-users-table">Загрузка…</div>
    </div>
  `;
  bindHeader();

  const searchEl = root.querySelector('#admin-search');
  const countEl = root.querySelector('#admin-count');
  const tableEl = root.querySelector('#admin-users-table');

  let query = '';
  const reload = async () => {
    tableEl.textContent = 'Загрузка…';
    try {
      const data = await api.admin.listUsers({ q: query, limit: 200 });
      countEl.textContent = `${data.total} пользователей`;
      tableEl.innerHTML = renderTable(data.users);
      bindRowActions(tableEl, reload);
    } catch (err) {
      if (err.status === 403) {
        tableEl.innerHTML = '<div class="text-muted">Нужны права администратора.</div>';
      } else {
        tableEl.textContent = 'Ошибка загрузки: ' + (err.message || '');
      }
    }
  };

  let t;
  searchEl.addEventListener('input', () => {
    clearTimeout(t);
    t = setTimeout(() => {
      query = searchEl.value.trim();
      reload();
    }, 200);
  });

  await reload();
}

function renderTable(users) {
  if (!users.length) return '<div class="text-muted">Пусто.</div>';
  return `
    <table>
      <thead>
        <tr>
          <th>Email</th><th>Роль</th><th>Уровень</th><th>Форма</th><th>Выучил</th><th>Verified</th><th>Создан</th><th></th>
        </tr>
      </thead>
      <tbody>
        ${users.map((u) => `
          <tr data-id="${u.id}">
            <td class="cell-email"><span>${escapeHtml(u.email)}</span></td>
            <td><span class="role-tag role-${u.role}">${u.role === 'admin' ? 'админ' : 'юзер'}</span></td>
            <td>${u.currentLevel}</td>
            <td>${Math.round(u.formScore)} <span class="text-muted">${u.formTier}</span></td>
            <td>${u.mastered}</td>
            <td>${u.emailVerified ? '✓' : '<span class="text-muted">—</span>'}</td>
            <td class="text-muted">${fmtDate(u.createdAt)}</td>
            <td><button class="btn-ghost btn-sm" data-action="edit">Править</button></td>
          </tr>
        `).join('')}
      </tbody>
    </table>
  `;
}

function bindRowActions(container, reload) {
  container.querySelectorAll('button[data-action="edit"]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.closest('tr').dataset.id;
      openEditModal(id, reload);
    });
  });
}

async function openEditModal(id, reload) {
  let detail;
  try {
    detail = await api.admin.showUser(id);
  } catch {
    toast('Не удалось загрузить пользователя', { type: 'error' });
    return;
  }

  const modal = document.createElement('div');
  modal.className = 'modal-backdrop';
  modal.innerHTML = `
    <div class="modal admin-edit-modal">
      <div class="admin-edit-head">
        <h2>Редактировать пользователя</h2>
        <button class="burger-close" id="close-modal" aria-label="Закрыть">✕</button>
      </div>
      <form id="edit-form">
        <div class="field"><label>Email</label><input type="email" id="f-email" value="${escapeHtml(detail.user.email)}" /></div>
        <div class="field">
          <label>Роль</label>
          <select id="f-role">
            <option value="user" ${detail.user.role === 'user' ? 'selected' : ''}>user</option>
            <option value="admin" ${detail.user.role === 'admin' ? 'selected' : ''}>admin</option>
          </select>
        </div>
        <div class="field">
          <label>Уровень</label>
          <select id="f-level">
            ${['A1','A2','B1','B2'].map((l) => `<option value="${l}" ${detail.user.currentLevel === l ? 'selected' : ''}>${l}</option>`).join('')}
          </select>
        </div>
        <div class="field"><label>Форма</label><input type="number" min="0" max="100" step="0.1" id="f-form" value="${detail.user.formScore}" /></div>
        <div class="field field-checkbox">
          <label><input type="checkbox" id="f-verified" ${detail.user.emailVerified ? 'checked' : ''}/> Email подтверждён</label>
        </div>
        <div class="field"><label>Новый пароль (опционально)</label><input type="password" id="f-password" placeholder="оставь пустым, если менять не надо" minlength="8" /></div>

        <div class="admin-stats">
          <div><strong>Выучено:</strong> ${detail.stats.mastered}</div>
          <div><strong>В работе:</strong> ${detail.stats.inDrum}</div>
          <div><strong>Попыток всего:</strong> ${detail.stats.totalAttempts}</div>
          <div><strong>Создан:</strong> ${fmtDate(detail.user.createdAt)}</div>
          <div><strong>Последняя активность:</strong> ${fmtDate(detail.user.lastActiveDate)}</div>
        </div>

        <div class="admin-edit-actions">
          <button type="button" class="btn-ghost" id="reset-progress">Сбросить прогресс</button>
          <button type="button" class="btn-ghost danger" id="delete-user">Удалить</button>
          <button type="submit" id="save-user">Сохранить</button>
        </div>
        <div class="form-error" id="modal-error"></div>
      </form>
    </div>
  `;
  document.body.appendChild(modal);

  const close = () => modal.remove();
  modal.querySelector('#close-modal').addEventListener('click', close);
  modal.addEventListener('click', (e) => { if (e.target === modal) close(); });

  const err = modal.querySelector('#modal-error');

  modal.querySelector('#edit-form').addEventListener('submit', async (e) => {
    e.preventDefault();
    err.textContent = '';
    const patch = {
      email: modal.querySelector('#f-email').value.trim(),
      role: modal.querySelector('#f-role').value,
      currentLevel: modal.querySelector('#f-level').value,
      formScore: Number(modal.querySelector('#f-form').value),
      emailVerified: modal.querySelector('#f-verified').checked,
    };
    const password = modal.querySelector('#f-password').value;
    if (password) patch.newPassword = password;
    try {
      await api.admin.updateUser(id, patch);
      toast('Сохранено', { type: 'success' });
      close();
      reload();
    } catch (e2) {
      if (e2.status === 409) err.textContent = 'Email уже занят';
      else err.textContent = e2.message || 'Не получилось сохранить';
    }
  });

  modal.querySelector('#reset-progress').addEventListener('click', async () => {
    if (!confirm('Сбросить прогресс и форму пользователя? Это снесёт все попытки и карточки.')) return;
    try {
      await api.admin.resetProgress(id);
      toast('Прогресс сброшен', { type: 'success' });
      close();
      reload();
    } catch (e2) {
      err.textContent = e2.message || 'Не получилось сбросить';
    }
  });

  modal.querySelector('#delete-user').addEventListener('click', async () => {
    if (!confirm('Удалить пользователя полностью? Восстановить нельзя.')) return;
    try {
      await api.admin.deleteUser(id);
      toast('Удалён', { type: 'success' });
      close();
      reload();
    } catch (e2) {
      err.textContent = e2.message || 'Не получилось удалить';
    }
  });
}
